import request from '@/common/request'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  createEmergencyKeyDetail: (dynaSeg, data, params) => {
    return request({
      url: '/emergencyKeyDetail',
      method: 'post',
      data,
      params
    })
  },
  deleteEmergencyKeyDetail: (dynaSeg, data, params) => {
    return request({
      url: `/emergencyKeyDetail/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateEmergencyKeyDetail: (dynaSeg, data, params) => {
    return request({
      url: `/emergencyKeyDetail/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryEmergencyKeyDetail: params => {
    return request({
      url: '/emergencyKeyDetail',
      method: 'get',
      params
    })
  },
  emergencyKeySubmitAudit: dynaSeg => {
    return request({
      url: `/emergencyKeyDetail/submit/${dynaSeg.id}`,
      method: 'post'
    })
  },
  getEmergencyKeyAuditDetail: data=> {
    return request({
      url: `/emergencyKeyDetail/getAuditDetail`,
      method: 'post',
      data
    })
  },
  getEmergencyKeyAuditEditDetail: data=> {
    return request({
      url: `/emergencyKeyDetail/getAuditEditDetail`,
      method: 'post',
      data
    })
  },
  emergencyKeyAuditEdit: data=> {
    return request({
      url: `/emergencyKeyDetail/auditEditSubmit`,
      method: 'post',
      data
    })
  },
  emergencyKeyDetailReturnKey: params => {
    return request({
      url: '/emergencyKeyDetail/returnKey',
      method: 'get',
      params
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/emergencyKeyDetail.js